import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function EditProcess() {
  const { country, id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const editorRef = useRef(null);

  const applyFormat = (command) => {
    document.execCommand(command, false, null);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/getprocesses/${encodeURIComponent(country)}`, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const process = (res.data || []).find((item) => String(item.Id) === String(id));
        if (process) {
          setTitle(process.Title || "");
          if (editorRef.current) {
            editorRef.current.innerHTML = process.ProcessCode || "";
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [country, id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const processCode = (editorRef.current?.innerHTML || "").trim();
    if (!title.trim() || !processCode) {
      alert("All fields are required!");
      return;
    }

    axios
      .put(
        `${BASE_URL}/updateprocess`,
        { Id: id, Title: title.trim(), ProcessCode: processCode },
        {
          headers: {
            Authorization: apiKey,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        navigate(`/countries/${country}/process`);
      })
      .catch((error) => console.log(error));
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>Update Process</h2>
      <br />
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6">
            <input
              className="form-control"
              placeholder="Process Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12">
            <div className="mb-2">
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("bold")}
              >
                B
              </button>
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("italic")}
              >
                I
              </button>
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("underline")}
              >
                U
              </button>
            </div>
            <div
              ref={editorRef}
              contentEditable
              className="form-control"
              style={{
                color: "#000",
                height: "250px",
                border: "1px solid #ccc",
                padding: "10px",
                overflowY: "auto",
              }}
            ></div>
          </div>
        </div>
        <br />
        <button className="btn btn-primary">Update Process</button>
      </form>
    </div>
  );
}
